export const buzzwords = [
  'Synergy',
  'Disruption',
  'Leverage',
  'Pivot',
  'Bandwidth',
  'Holistic',
  'Scalable',
  'Low-hanging fruit',
  'Ecosystem',
  'Value-add',
  'Paradigm shift',
  'Agile',
  'Deep dive',
  'Move the needle',
  'ROI',
  'Thought leader',
  'KPI',
  'Onboarding',
  'Alignment',
  'Seamless',
  'Streamline',
  'Optimization',
  'Stakeholders',
  'Cross-functional',
  'Empower',
  'Growth hacking',
  'Monetize',
  'Best practices',
  'Buy-in',
  'Quick win',
  'Visibility',
  'Customer-centric',
  'Iteration',
  'Touchpoint',
  'Scalability',
  'Granular',
  'Benchmarking',
  'Strategic partnership',
  'Blue-sky thinking',
  'Core competency',
  'Pain point',
  'Deliverable',
  'Roadmap',
  'Mission-critical',
  'Robust',
  'Tailwind',
  'Disruptive innovation',
  'Continuous improvement',
  'Data-driven',
  'End-to-end',
  'Retention',
];
